import dynamic from "next/dynamic";

const Link = dynamic(() => import("@/components/ui/Link"), { ssr: false });

interface AuthorDisplayProps {
  author?: {
    slug: string;
    title: string;
  } | null;
  className?: string;
  showByPrefix?: boolean;
  defaultAuthor?: {
    slug: string;
    title: string;
  };
}

export default function AuthorDisplay({
  author,
  className = "text-xl font-greycliff text-white leading-7 tracking-tight",
  showByPrefix = false,
  defaultAuthor = {
    slug: "meet-dr-bader",
    title: "Bradford Bader, MD",
  },
}: AuthorDisplayProps) {
  // Use provided author or default
  const displayAuthor = author || defaultAuthor;
  const authorUrl = `/about/meet-dr-bader/`;

  if (showByPrefix) {
    return (
      <span className="mr-1">
        by{" "}
        {authorUrl ? (
          <Link href={authorUrl} className={className}>
            {displayAuthor.title}
          </Link>
        ) : (
          <span className={className}>{displayAuthor.title}</span>
        )}
      </span>
    );
  }

  return (
    <>
      {authorUrl ? (
        <Link href={authorUrl} className={className}>
          {displayAuthor.title}
        </Link>
      ) : (
        <span className={className}>
          {displayAuthor.title}
        </span>
      )}
    </>
  );
}
